import { Component, computed, inject, model, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { TransportService } from '../../services/transport.service';
import { TransportOutConfiguration } from '../../models/transport-configuration';
import { DistributionService } from 'src/app/distribution/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SingleselectboxComponent } from '../../../controls/components/basic/singleselectbox/singleselectbox.component';
import { ButtonComponent } from '../../../controls/components/basic/button/button.component';
import { ButtonTertieryDirective } from '../../../controls/directives/button-tertiery.directive';
import { ButtonSecondaryDirective } from '../../../controls/directives/button-secondary.directive';
import { ButtonPrimaryDirective } from '../../../controls/directives/button-primary.directive';

@Component({
    selector: 'app-transport-out-override-dialog',
    templateUrl: './transport-out-override-dialog.component.html',
    styleUrls: ['./transport-out-override-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SingleselectboxComponent, ButtonComponent, ButtonTertieryDirective, ButtonSecondaryDirective, ButtonPrimaryDirective]
})
export class TransportOutOverrideDialogComponent implements OnInit {
  private transportService = inject(TransportService);
  private distributionService = inject(DistributionService);
  private dialog = inject(NgbActiveModal);

  overrideId = model<number>(0);
  initialOverrideId = signal(0);
  globalLocations = signal<TransportOutConfiguration[]>([]);
  distributionCount = signal<number>(-1);
  dialogStep = signal(1);
  selectedLocation = computed(() => this.globalLocations().find(e => e.Id === this.overrideId()));
  canNext = computed(() => {
    return !!this.selectedLocation() && this.overrideId() !== this.initialOverrideId();
  });

  ngOnInit(): void {
    this.init();
  }

  async init(): Promise<void> {
    this.initialOverrideId.set(this.overrideId());
    this.globalLocations.set(await this.transportService.getGlobalTransportOutConfigurations());
    this.distributionCount.set(await this.distributionService.getDistributionCount());
  }

  cancel(): void {
    this.dialog.dismiss();
  }

  goBack(): void {
    this.dialogStep.set(1);
  }

  confirmOverride(): void {
    this.dialogStep.set(2);
  }

  confirmStop(): void {
    this.dialogStep.set(3);
  }

  stopNow(): void {
    this.dialog.close(undefined);
  }

  overrideNow(): void {
    this.dialog.close(this.overrideId());
  }
}
